import { EligibilityLiveCareChildrenScreen } from "@/interactors/EligibilityLiveCareChildrenScreen";

export default function LiveAndCareChildren() {
  return <EligibilityLiveCareChildrenScreen />;
}
